import { render } from "./CenterPanel.vue?vue&type=template&id=6783a60a&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"

import "./CenterPanel.vue?vue&type=style&index=0&id=6783a60a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6783a60a"

export default script